import Vue from 'vue'
import VTooltip from 'v-tooltip'
import {sync} from 'vuex-router-sync'
import {abilitiesPlugin} from '@casl/vue'
import permissionService from './state/services/Permission'
import Notifications from 'vue-notification'
import Vuelidate from 'vuelidate'
import VueGtag from 'vue-gtag'
import i18n from './i18n'
import router from './router'
import store from './state/store'
import './assets/tailwind.css'
import './assets/scrollbar.css'
import './registerServiceWorker'
import 'simplebar'
import 'simplebar/dist/simplebar.css'
import App from './App.vue'

sync(store, router)

Vue.config.productionTip = false
Vue.config.silent = true

Vue.use(Notifications)
Vue.use(VTooltip)
Vue.use(abilitiesPlugin, permissionService)
Vue.use(Vuelidate)

const isProd = true

VTooltip.options.popover.defaultPopperOptions = {
  modifiers: {
    computeStyle: {
      gpuAcceleration: false,
    },
  },
}
VTooltip.options.defaultPopperOptions = {
  modifiers: {
    computeStyle: {
      gpuAcceleration: false,
    },
  },
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
